export const imageHelpers = {
    upload: (obj, cb) => {
        console.log('imageHelpers obj', obj);
        const { data, file } = obj;
        const AWS = require('aws-sdk');
        AWS.config.update({
            accessKeyId: "AKIAJQT3DWNFJLNNG5YA",
            secretAccessKey: "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",
            AWSRegion: "us-east-1"
        });
        const s3 = new AWS.S3();
        const base64Data = new Buffer(data.replace(/^data:image\/\w+;base64,/, ""), 'base64');

        // Getting the file type, ie: jpeg, png or gif
        //const type = data.split(';')[0].split('/')[1];
        const type = file.type.split('/')[1];
        const params = {
            Bucket: "toneevents",
            Key: `images/${new Date().getTime() + (Math.random() * 1000)}.${type}`,
            Body: base64Data,
            ACL: 'public-read',
            ContentEncoding: 'base64', // required
            //ContentType: `image/${type}` // required. Notice the back ticks
            ContentType: file.type // required. Notice the back ticks
        };

        // The upload() is used instead of putObject() as we'd need the location url and assign that to our user profile/database
        // see: http://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#upload-property
        s3.upload(params, (err, data) => {
            if (err){
                console.log('Image uploaded error : ', err);
                cb(err);
            }
            else {
                console.log('Image uploaded successfully : ', data);
                cb(null, data);
            }

        });
    }
};





// WEBPACK FOOTER //
// ./src/helpers/lambda.js